import React from 'react';

import cn from 'classnames';

import IconFemtasy, { iconSize } from 'components/IconFemtasy';
import { FemtasyIcon } from 'components/IconFemtasy/iconsType';

import palette from 'styles/base/palette.module.scss';
import { Color, PaletteColor } from 'types/colors';

import './style.scss';

const calculateIconButtonSize = (size?: IconButtonSize) => {
  const defaultButtonSize: IconButtonSize = '24';

  if (size) {
    const iconButtonSize = Number(size) / 2; // The inside icon size is proportionally half of the outter circle size.

    return String(iconButtonSize) as iconSize;
  }

  return defaultButtonSize;
};

export type IconButtonSize = '16' | '24' | '32' | '40' | '64';

export interface IProps {
  backgroundColor?: PaletteColor;
  borderWidth?: number;
  color?: Color;
  className?: string;
  icon: FemtasyIcon;
  loading?: boolean;
  outlineColor?: PaletteColor;
  size?: IconButtonSize;
}

const IconButton = ({
  backgroundColor = 'primary',
  borderWidth = 0,
  color = 'white',
  className,
  icon,
  loading,
  outlineColor = 'primary',
  size,
}: IProps) => {
  const buttonClassNames = cn('IconButton', className, `IconButton--${size}`, {
    'IconButton--loading': loading,
  });

  const iconSize = calculateIconButtonSize(size);

  return (
    <button
      className={buttonClassNames}
      disabled={loading}
      style={{
        backgroundColor: palette[backgroundColor],
        borderColor: palette[outlineColor],
        borderWidth,
        borderStyle: 'solid',
      }}
    >
      <IconFemtasy size={iconSize} icon={icon} color={color} />
    </button>
  );
};

export default IconButton;
